import React from 'react'
import IncidentPerAttribute from './IncidentPerAttribute'


const GeneralIncidentsPerRegion = () => {

    const monitorReport = false;

    return (
        <>
            <IncidentPerAttribute monitorReport={monitorReport} attributeType ="REGION" disaggregation = "validity"/>
        </>
    
  )
}

export default GeneralIncidentsPerRegion